import React from "react";
import style from "./index.module.scss";
interface OtherItem {
    name: string;
    count: number;
    unit?: string;
}
interface GeneralCardProps {
    bgImg?: string; //背景图片
    name: string; //卡片名
    icon: string; //卡片图标
    count: number; //卡片主要次数数据
    others: OtherItem[]; //底部其它选项
}
export default function CardInfo({
    bgImg,
    name,
    icon,
    count,
    others
}: GeneralCardProps) {
    return (
        <div
            className={style.cardInfo}
            style={{ backgroundImage: `url(${bgImg})` }}>
            {/* <img className={style.bgImg} src={bgImg} alt="" /> */}
            <img className={style.icon} src={icon} alt="" />
            <div>
                <p className={style.name}>{name}</p>
                <p>
                    {" "}
                    <span className={style.count}>{count}</span>&nbsp;&nbsp;次
                </p>
                <div className={style.others}>
                    {others?.map((el: OtherItem) => {
                        return (
                            <p className={style.otherItemOne} key={el.name}>
                                <span>{el.name}&nbsp;</span>
                                <span className={style.otherCount}>
                                    {el.count}&nbsp;
                                </span>
                                <span>{el.unit}</span>
                            </p>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
